import { IQuestionModelState, IQuestionSchema, IResponseValidation, QuestionModelTypes, QuestionType } from '../types'

export interface IComboboxQuestionSchema extends IQuestionSchema {
  type: QuestionType.COMBOBOX
  selectoptions: {
    uid: string
  }
}

export type ComboboxQuestionOptions = {
  id?: string
  l: string | number
  o?: boolean
  v?: []
}[]

export type ComboboxSubmitResponse = {
  id: string
  c?: string
}[]

export interface IComboboxResponseValidation extends IResponseValidation {
  //
}

export interface ComboboxQuestionModelTypes extends QuestionModelTypes {
  schema: IComboboxQuestionSchema
  response: ComboboxSubmitResponse
  responseValidation: IComboboxResponseValidation
  submitResponse: ComboboxSubmitResponse
}

export interface IComboboxQuestionModelState extends IQuestionModelState<ComboboxQuestionModelTypes> {
  //
}

export const EMPTY_SUBMIT_RESPONSE: ComboboxSubmitResponse = []

// status - remove
